
import axiosNew from "../../../helpers/axios"
import { buildQueryParams } from "../../../utils/commonUtils"


export const uploadResume = async (payload) => {
    let data = payload ?? {}
    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url: 'aws/upload-file',
                data,
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// export const uploadResumeS3Url = async (file, url) => {
//     // let data = payload ?? {}
//     return new Promise(async (resolve) => {
//         try {
//            
//             const res = await axiosNew({
//                 url: url,
//                 method: "PUT",
//                 data: file,
//             })
//             // resolve({ data: res.data ?? {} })
//         } catch (error) {
//             console.log("🚀 ~ returnnewPromise ~ error:", error)
//             resolve({ data: error?.response?.data ?? {} })
//         }
//     })
// }



// export const uploadResumeS3Url = async (file, url) => {


//     try {
//         const date = await axios.put(url, file, {
//             headers: {
//                 'Content-Type': 'application/octet-stream',
//             },
//         })

//     } catch (error) {
//         console.log("🚀 ~ uploadResumeS3Url ~ error:", error)

//     }
// }


export const uploadResumeS3Url = async (file, url) => {
    try {
        const formData = new FormData();
        formData.append("file", file);  // Assuming the file is passed as 'file'
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                "Content-Type": file.type,
            },
            body: file?.originFileObj ? file.originFileObj : file
            ,  // Directly sending the file as the body of the request
        });

        if (!response.ok) {
            throw new Error(`Failed to upload file: ${response.statusText}`);
        }
        return response
    } catch (error) {
        console.log("🚀 ~ uploadResumeS3Url ~ error:", error);
    }
}


export const postAiUploadFileUrl = async (payload) => {
    let data = payload ?? {}
    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url: 'candidate',
                data,
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })

        }
    })
}


export const postCreateCandidate = async (payload) => {
    let data = payload ?? {}
    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url: 'candidate',
                data,
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const postEditCandidate = async (activeTab, id, payload) => {
    // let data = payload ?? {}

    try {
        const res = await axiosNew({
            url: `candidate?section=${activeTab}`,
            data: payload,
            method: "PUT"
        })
        return ({ data: res.data ?? {} })
    } catch (error) {
        throw error
    }

}

export const getCandidateList = async (skip, limit, filter = {}, search = '', sort, sortType) => {
    const query = buildQueryParams(filter);

    // Construct base URL
    let url = `candidate?limit=${limit}&skip=${skip}`;
    if (sort && sortType) url += `&sort=${sort}&sortType=${sortType}`;
    // Append query only if it exists
    if (query) {
        url += `&${query}`;
    }

    // Append search only if it exists
    if (search) {
        url += `&search=${encodeURIComponent(search)}`;
    }

    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url,
                method: "GET"
            });
            resolve({ data: res.data ?? {} });
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} });
        }
    });
};


export const getCandidateById = async (id, activeTab) => {
    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url: `candidate/${id}?section=${activeTab}`,
                method: "GET"
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const postCandidateNote = async (CandidateId, payload) => {
    let data = payload ?? {}
    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url: `candidate/${CandidateId}/comments`,
                data: data
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const getCandidateNote = async (CandidateId) => {
    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url: `candidate/${CandidateId}/comments`,
                method: 'GET'
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}




